import React from 'react'

import Hdr from '../shared/Hdr';
import { Link } from 'react-router-dom';

import { useState, useEffect } from 'react';
import swal from 'sweetalert';

import { apiPath1 } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";


function Rolemgmnt() {

const token = localStorage.getItem('token');
const usrRole = localStorage.getItem('user-role');
const [adm, setAdm] = useState(false)
const [roledata, setRoleData] = useState([])
const [roleStatus, setRoleStat] = useState()
const [permdata, setPermData] = useState([])
const [permStatus, setPermStat] = useState()
const [RoleName, setRoleName]= useState('Permissions')
const [newRoleName, setNewRoleName]= useState()
const [displayCreateRole, setDisplayCreateRole] = useState(false);
const [displayAddPermission, setDisplayAddPermission] = useState(false);

const [permissiondata, setPermissionData] = useState([])
const [permissionStatus, setPermissionStat] = useState()
const [newPermission, setNewParmission] = useState()
const [selectedRole,setSelectedRole] = useState()


  useEffect(() => {
    if (usrRole === 'Administrator') {
      setAdm(true)
    }
    getRoles()
    getPermissions()
 //   getPermission(0)

  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };


    /* LIST OF ALL ROLE (for initial screen)*/
    async function getRoles() {
      let result = await fetch(apiPath1 + "Roles",
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
  
      result = await result.json();

      setRoleStat(result.status);
      setRoleData(result.data);
  
      if (result.status === false) { setRoleData([]) }
    }

    /* LIST OF ALL PERMISSIONS (for initial screen)*/
    async function getPermissions() {
        let result = await fetch(apiPath1 + "Permissions",
          {
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`
            },
          });
    
        result = await result.json();
  
        setPermissionStat(result.status);
        setPermissionData(result.data);
    
        if (result.status === false) { setPermissionData([]) }
      }


    /* LIST OF PERMISSION ROLE ID WISE*/
    async function getPermission(id, name) {

      
        setSelectedRole(id)
        setRoleName("Permissions of "+ name)
        let result = await fetch(apiPath1 + "RolePermissions/"+id,
          {
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`
            },
          });
    
        result = await result.json();


        setPermStat(result.status);
        setPermData(result.data);
    
        if (result.status === false) { setRoleData([]) }
      }


  function openCreateRole(){
    setDisplayCreateRole(true)
  }

  function closeCreateRole(){
    setDisplayCreateRole(false)

  }

  function openPermisonRole(){
    setDisplayAddPermission(true)

  }

  function closePermisonRole(){
    setDisplayAddPermission(false)
    
  }

  async function AddRole(){

          let result = await fetch(apiPath1 + "CreateRole", {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
              "name": newRoleName,
            })
          });

         // alert(result.status)
    
          result = await result.json();
          showSwal(result.status, result.msg)
    
          getRoles()
  }

  function RoleNameHandler(e){
    e.preventDefault()
    setNewRoleName(e.target.value)
  }

  async function AddPermission(){
   // alert(newPermission+', '+selectedRole )

    let result = await fetch(apiPath1 + "AssignPermissionToRole", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "role_id": selectedRole,
          "permission_id": newPermission
        })
      });

     // alert(result.status)

      result = await result.json();
      showSwal(result.status, result.msg)

     // getPermissions()
     getPermission(selectedRole, RoleName)

  }

  function permissionHandler(e){
    e.preventDefault()
    setNewParmission(e.target.value)
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  async function revokePerm(id) {

  //  alert(selectedRole +', '+id)

    let result = await fetch(apiPath1 + "RevokePermissionFromRole", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "role_id": selectedRole,
        "permission_id": id
      })
    });
   
    result = await result.json();
    showSwal(result.status, result.msg)

    getPermission(selectedRole, RoleName)
  }

  return (
    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Role Management'} />

      <div className="row p16" style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
        
            <div className="row p8" style={{ 'height': '100%'}}>
                <div className=" c12-l-6">
                    {/* CTA SECTION */}
                    <div className="row mb16">
                        <div className="c12-l-3"></div>           
                        <div className="c12-l-7"></div>
                        <div className="c12-l-2 align-bottom-right">
                            <button onClick={openCreateRole} type="button" name="button"
                                className="btn large gradient round">Create New Role</button>
                        </div>
                    </div>

                    <div className="c12-l-12 perm__content p4">
                        <table style={{ 'display': 'block' }}>
                            <thead className='thead-blue'>
                                <tr>
                                    <th className="th-border left" width="10%">Role ID</th>
                                    <th className="th-border left" width="20%">Name</th>
                                    <th className="th-border center" width="20%">Show Details</th>
                                </tr>
                            </thead>
                            <tbody >
                            {
                                (roleStatus === true ?
                                (
                                    roledata.map((item, index) =>
                                    <tr className="tr-two-color-grey" key={index}>
                                        <td className="">{item.id}</td>
                                        <td className="">{item.name}</td>
                                        <td onClick={()=>{getPermission(item.id, item.name)}} className="center"><button type="button" name="button" className="btn solid round" >Show</button></td>
                                    </tr>
                                    ))
                                : <tr><td>No data</td></tr>)
                            }
                            </tbody>
                        </table>
                    </div>

                    <AnimatePresence> {/* Wrap with AnimatePresence */}
                        {displayCreateRole && (
                        <motion.div 
                        key="sliding-container" // Crucial for AnimatePresence to work
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit" // Specify the exit animation
                        transition={transitionSettings}
                        id="newdept" 
                        className="cont__lineitem">
                        
                        <form className="" action="" method="">
                            <div className="row box gradient corner-round-t">
                            <div className="c12-l-11">
                                <h3 className='txt-subtlewhite'>Add Role</h3>
                            </div>
                            <div className="c12-l-1 align-right">
                                <p onClick={closeCreateRole}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                            </div>
                            </div>

                         
                            <div className="row mt16 px16">
                            <div className="c12-l-12">
            
                                <div className="row">
                                <div className="c12-l-3 mt8">
                                    <p>Role Name</p>
                                </div>
                                <div className="c12-l-9">              
                                    <input type="text" className="box small" maxlength="10"
                                    placeholder="Add New Role" onChange={RoleNameHandler} />
                                </div>
                                </div>

                                <br /><br />
                                <button onClick={AddRole} type="button"
                                className="btn gradient round right">Add New Role</button>

                            </div>
                            </div>

                          
                        </form>
                        </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                <div className=" c12-l-6">  
                    <div className="row mb16">
                        <div className="c12-l-3"></div>           
                        <div className="c12-l-7"></div>
                        <div className="c12-l-2 align-bottom-right">
                            <button onClick={openPermisonRole} type="button" name="button"
                                className="btn large gradient round">Add Permissiion</button>
                        </div>
                    </div>  
                    <div className="c12-l-12 perm__content p4">
                        <table style={{ 'display': 'block' }}>
                            <thead className='thead-blue'>
                                <tr>
                                <th className="th-border center" width="10%">Permission ID</th>
                                <th className="th-border left" width="20%">{RoleName}</th>
                                <th className="th-border left" width="10%">Revoke Permission</th>
                                </tr>
                            </thead>
                            <tbody >
                            {
                                (permStatus === true ?
                                (
                                    permdata.map((item, index) =>
                                    <tr className="tr-two-color-grey" key={index}>
                                        <td className="center">{item.id}</td>
                                        <td className="">{item.name}</td>
                                        <td className='txt-darkblue mb2' onClick={(e) => {revokePerm(item.id)}} style={{ cursor: 'pointer', textDecoration: 'underline' }}>revoke</td>
                                    </tr>
                                    ))
                                : <tr><td>No data</td></tr>)
                            }
                            </tbody>
                        </table>
                    </div>   
                    
                    
                    <AnimatePresence> {/* Wrap with AnimatePresence */}
                        {displayAddPermission && (
                        <motion.div 
                        key="sliding-container" // Crucial for AnimatePresence to work
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit" // Specify the exit animation
                        transition={transitionSettings}
                        id="newdept" 
                        className="cont__lineitem">
                        
                        <form className="" action="" method="">
                            <div className="row box gradient corner-round-t">
                            <div className="c12-l-11">
                                <h3 className='txt-subtlewhite'>Add Permission</h3>
                            </div>
                            <div className="c12-l-1 align-right">
                                <p onClick={closePermisonRole}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                            </div>
                            </div>

                         
                            <div className="row mt16 px16">
                            <div className="c12-l-12">
           
                                <div className="row">
                                <div className="c12-l-3 mt8">
                                    <p>Permissions</p>
                                </div>
                                <select className="custom-select" onChange={permissionHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                                <option value="0" >Select Permission</option>
                                {
                                    (permissionStatus === true ?
                                      (
                                        permissiondata.map((item, index) =>
                                          <option key={item.id} value={item.id}>{item.name}</option>
                                        )
                                      )
                                      :
                                      <option>No Data </option>
                                    )
                                  }
                                </select>
                                </div>

                                <br /><br />
                                <button onClick={AddPermission} type="button"
                                className="btn large gradient round right">Add New Permission</button>

                            </div>
                            </div>

                          
                        </form>
                        </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Rolemgmnt
